import { render, staticRenderFns } from "./BookingCreatePage.vue?vue&type=template&id=53479d83&"
import script from "./BookingCreatePage.vue?vue&type=script&lang=js&"
export * from "./BookingCreatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports